// Non-param sidebar entry points for the tournament-scoped Intl Acca
// screens. The design's IA sidebar (video) exposes Today's Slip /
// Tournament Hub / DNA Profiles / Debrief as flat destinations, but
// the underlying routes are tournament-scoped (/intl-acca/:id/...).
// This resolver picks the active tournament (Topbar-switcher /
// localStorage selection, else the soonest PRE/ACTIVE one) and
// redirects. No tournament at all ⇒ fall back to the Calendar (the
// honest entry — nothing to show yet). No fabrication.

import { Navigate } from "react-router-dom";
import { useIntlAccaTournaments } from "../../intl-acca/useIntlAccaTournaments.ts";

type Dest = "home" | "hub" | "dna" | "debrief";

export function IntlAccaResolveRoute({ dest }: { dest: Dest }): JSX.Element {
  const { loading, tournaments, activeId } = useIntlAccaTournaments();

  if (loading) {
    return (
      <div className="ia-empty" style={{ padding: "48px 0", textAlign: "center" }}>
        <span className="ia-eyebrow">Resolving tournament…</span>
      </div>
    );
  }

  const id = activeId ?? tournaments[0]?.id ?? null;
  if (!id) return <Navigate to="/intl-acca/calendar" replace />;

  const to =
    dest === "hub" ? `/intl-acca/${id}/hub`
    : dest === "dna" ? `/intl-acca/${id}/dna`
    : dest === "debrief" ? `/intl-acca/debrief/${id}`
    : `/intl-acca/${id}`;
  return <Navigate to={to} replace />;
}
